'use client'

import { qrUriAtom } from 'features/generator/generatorState'
import { useHydrateAtoms } from 'jotai/utils'

import { TUrlContent, websiteUrlContentAtom } from './WebsiteUrlContentState'
import { WebsiteUrlScreen } from './WebsiteUrlScreen'

export const WebsiteUrlLandingScreen = ({
	uri,
	content,
}: {
	uri: string
	content: TUrlContent
}) => {
	useHydrateAtoms([
		[qrUriAtom, uri],
		[websiteUrlContentAtom, content],
	])

	return <WebsiteUrlScreen demoMode={false} previewMode={false} />
}
